import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const WorkflowActionChangeStatusIcon = ({ className = "w-8 h-8" }) => (
  <SvgSpriteIcon iconName="workflow-actions-change-status" className={className} />
)

WorkflowActionChangeStatusIcon.propTypes = {
  className: types.string,
}

export default WorkflowActionChangeStatusIcon
